export const COMPETENCY_FRAMEWORK = {
  path: 'competency_framework',
  name: 'competency_framework',
  meta: {
    title: 'competency_framework.recruiter.meta',
    permissions: ['competency_framework_group_r']
  },
  component: () => import('@/views/recruiter/CompetencyFrameworkTableView.vue')
};
